"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PropertyCardMLSFooterMixin = void 0;
var _styledComponents = require("styled-components");
var _styledToken = _interopRequireDefault(require("styled-token"));
var _Image = require("../../components/Image/Image.styles");
var _Text = require("../../components/Text/Text.styles");
var _constants = require("../../constants");
var _spaceMixin = require("../spaceMixin");
var _typographyMixin = require("../typographyMixin");
/** @class PropertyCardMLSFooterMixin */
/** @method */
var PropertyCardMLSFooterMixin = function PropertyCardMLSFooterMixin(props) {
  return (0, _styledToken.default)({
    background: 'PropertyCard.mls.background',
    fontColor: 'PropertyCard.mls.fontColor',
    fontType: "PropertyCard.mls.fontType." + _constants.PROPERTY_CARD_APPEARANCES.LARGE,
    fontWeight: 'PropertyCard.mls.footer.text.fontWeight',
    footerPadding: ['PropertyCard.mls.footer.padding'],
    gridColumnTemplate: 'PropertyCard.mls.footer.templateColumns',
    gridGap: 'PropertyCard.mls.footer.gap',
    textPaddingBottom: 'PropertyCard.mls.text.paddingBottom',
    textShadow: 'PropertyCard.mls.textShadow'
  }, function (_ref) {
    var background = _ref.background,
      fontColor = _ref.fontColor,
      fontType = _ref.fontType,
      fontWeight = _ref.fontWeight,
      footerPadding = _ref.footerPadding,
      gridGap = _ref.gridGap,
      _ref$gridColumnTempla = _ref.gridColumnTemplate,
      gridColumnTemplate = _ref$gridColumnTempla === void 0 ? '1fr min-content' : _ref$gridColumnTempla,
      textPaddingBottom = _ref.textPaddingBottom,
      textShadow = _ref.textShadow;
    return (0, _styledComponents.css)(["align-items:end;background:", ";display:grid;grid-gap:", ";grid-template-columns:", ";padding:", ";", "{", " font-weight:", ";color:", ";padding-bottom:", ";text-shadow:", ";}", "{max-width:none;}"], background, gridGap ? gridGap + "px" : (0, _spaceMixin.spaceMixin)('xs')(props), gridColumnTemplate, footerPadding ? footerPadding.top + "px " + footerPadding.right + "px " + footerPadding.bottom + "px " + footerPadding.left + "px" : (0, _spaceMixin.spaceMixin)('xs')(props) + " " + (0, _spaceMixin.spaceMixin)(0.5)(props) + " " + (0, _spaceMixin.spaceMixin)(0.5)(props) + "\n                " + (0, _spaceMixin.spaceMixin)('xs')(props), _Text.StyledText, (0, _typographyMixin.typographyMixin)(Object.assign({
      fontColor: fontColor,
      fontType: fontType
    }, props)), fontWeight, fontColor, textPaddingBottom ? textPaddingBottom + "px" : (0, _spaceMixin.spaceMixin)(0.25)(props), textShadow, _Image.StyledImage);
  })(props);
};
exports.PropertyCardMLSFooterMixin = PropertyCardMLSFooterMixin;